<template>
  <tr class="border-strokes border-t border-solid">
    <td class="px-4! py-2!">
      <div class="flex"><RfBaseSkeleton height="25" width="120" dynamic /></div>
    </td>
    <td class="px-4! py-2!">
      <div class="flex"><RfBaseSkeleton height="25" width="120" dynamic /></div>
    </td>

    <td v-if="!alternative && fullView" class="min-w-64 px-4! py-2!">
      <div class="flex"><RfBaseSkeleton height="25" width="120" dynamic /></div>
    </td>

    <td v-if="alternative" class="px-4! py-2!">
      <div class="flex"><RfBaseSkeleton height="25" width="120" dynamic /></div>
    </td>

    <td class="px-4! py-2!">
      <div class="flex"><RfBaseSkeleton height="25" width="120" dynamic /></div>
    </td>

    <td v-if="fullView" class="min-w-32"><RfBaseSkeleton height="25" width="100" dynamic /></td>

    <td class="min-w-64 px-4! py-2!">
      <div class="flex"><RfBaseSkeleton height="25" width="120" dynamic /></div>
    </td>
  </tr>
</template>

<script setup>
import RfBaseSkeleton from "@/components/skeletons/RfBaseSkeleton.vue";

defineProps({
  alternative: { type: Boolean, default: false },
  fullView: { type: Boolean, default: false },
});
</script>
